import { render, staticRenderFns } from "./labelRecordView.vue?vue&type=template&id=30ad7ae4&scoped=true&"
import script from "./labelRecordView.vue?vue&type=script&lang=js&"
export * from "./labelRecordView.vue?vue&type=script&lang=js&"
import style0 from "./labelRecordView.vue?vue&type=style&index=0&id=30ad7ae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ad7ae4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30ad7ae4')) {
      api.createRecord('30ad7ae4', component.options)
    } else {
      api.reload('30ad7ae4', component.options)
    }
    module.hot.accept("./labelRecordView.vue?vue&type=template&id=30ad7ae4&scoped=true&", function () {
      api.rerender('30ad7ae4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/labelRecordView.vue"
export default component.exports